// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Ft05","content":"styles_content__3UT88","selectAll":"styles_selectAll__10X8V"};